// Auto-generated from cloud-connections domain registry
// Domain: cloud-connections

export enum CloudConnectionEventNames {
  VALIDATE_AWS = "cloud_connection.validate_aws",
  VALIDATE_GCP = "cloud_connection.validate_gcp",
  VALIDATE_AZURE = "cloud_connection.validate_azure",
  GENERATE_AZURE_TEMPLATE = "cloud_connection.generate_azure_template",
  CONNECTION_VALIDATED = "cloud_connection.validated",
  CONNECTION_FAILED = "cloud_connection.validation_failed",
  CONNECTION_ERROR = "cloud_connection.error",
  CONNECTION_CREATED = "cloud_connection.created",
  CONNECTION_DELETED = "cloud_connection.deleted",
}

export enum CloudConnectionEndpoints {
  LIST = "/api/v1/connections",
  GET = "/api/v1/connections/:id",
  DELETE = "/api/v1/connections/:id",
  AWS_SETUP_INFO = "/api/v1/connections/aws/setup-info",
  AWS_VALIDATE = "/api/v1/connections/aws/validate",
  GCP_SETUP_INFO = "/api/v1/connections/gcp/setup-info",
  GCP_VALIDATE = "/api/v1/connections/gcp/validate",
  AZURE_ARM_TEMPLATE = "/api/v1/connections/azure/arm-template",
  AZURE_VALIDATE = "/api/v1/connections/azure/validate",
  CREATE_TARGET = "/api/v1/connections/:connectionId/targets",
}
